import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";
import { useQuery } from "@apollo/client";
import { Link } from "react-router-dom";

import HeaderBox from "../../reuseableComponents/headerBox/HeaderBox";
import {
  GET_ALL_IPS_VIOLATIONS,
  GET_ALL_ANALYTES,
  GET_ALL_ANALYTE_GROUPS,
  GET_ALL_VIOLATION_TYPES,
  GET_ALL_SECTIONS
} from "../../../queries/archiveQrys/secureQrys/ipsViolationQrys";
import IpsViolationsTable from "./IpsViolationsTable";
import SkeletonLoader from "../../reuseableComponents/loaders/SkeletonLoader";
import ErrorMessage from "../../reuseableComponents/ErrorHandler";
import ButtonCreate from "../../reuseableComponents/buttons/ButtonCreate";
import ModalWindow from "../../reuseableComponents/ModalWindow";
import IpsViolationsForm from "./IpsViolationsForm";
import AnalyteGroupForm from "./AnalyteGroupForm";

const IpsViolationAdminPage = () => {
  const [show, setShow] = useState(false);
  const [showAG, setShowAG] = useState(false);
  const [item, setItem] = useState(null);
  const [modalId, setModalId] = useState(null);
  const [modalAG, setModalAG] = useState(null);
  const [submitSuccess, setSubmitSuccess] = useState(null);
  const [submitError, setSubmitError] = useState(null);

  const { data: tableData, loading: tableLoading, error: tableError } = useQuery(GET_ALL_IPS_VIOLATIONS);
  const { data: analyteData, loading: analyteLoading, error: analyteError } = useQuery(GET_ALL_ANALYTES);
  const { data: groupData, loading: groupsLoading, error: groupsError } = useQuery(GET_ALL_ANALYTE_GROUPS);
  const { data: sectionData, loading: sectionsLoading, error: sectionsError } = useQuery(GET_ALL_SECTIONS);

  const handleClose = () => {
    setShow(false);
    setItem(null);
  };

  const handleCloseAG = () => {
    setShowAG(false);
    setItem(null);
  };

  const handleShowAG = (id) => {
    setShowAG(id);
    setModalAG(id);
  };

  const handleShow = (id) => {
    setSubmitSuccess(null);
    setSubmitError(null);
    setShow(id);
    setModalId(id);
  };

  const setItemObj = (value) => {
    setItem(value);
  };

  const {
    data: violationsData,
    loading: violationsLoading,
    error: violationsError
  } = useQuery(GET_ALL_VIOLATION_TYPES);

  if (
    tableLoading ||
    analyteLoading ||
    violationsLoading ||
    groupsLoading ||
    sectionsLoading ||
    tableError ||
    analyteError ||
    violationsError ||
    analyteError ||
    groupsError ||
    sectionsError
  ) {
    return (
      <div className='page-container ips-violation-admin-container'>
        <Row>
          <Col>
            <Link className='m-2 hyperlink' to='/' cypressid='home-page'>
              Home
            </Link>
            <span className='m-2'>|</span>
            <Link className='m-2 hyperlink' to='/secure/module-index' cyressid='module-index'>
              Modules
            </Link>
            <span className='m-2'>|</span>
            <Link className='m-2 hyperlink' to='/secure/ips/ips-index' cyressid='ips-index'>
              IPS Menu
            </Link>
          </Col>
        </Row>
        <Row>
          <Col>
            <HeaderBox id={"gray-primary"} cypressid='ipsViolationsPage'>
              <h3 style={{ color: "#fff" }}>IPS Violations Admin</h3>
            </HeaderBox>
          </Col>
        </Row>
        <Row>
          <Col>
            {(tableLoading || analyteLoading || violationsLoading || groupsLoading || sectionsLoading) && (
              <SkeletonLoader width='100%' />
            )}
            {tableError && <ErrorMessage error={tableError} />}
            {analyteError && <ErrorMessage error={analyteError} />}
            {violationsError && <ErrorMessage error={violationsError} />}
            {groupsError && <ErrorMessage error={groupsError} />}
            {sectionsError && <ErrorMessage error={sectionsError} />}
          </Col>
        </Row>
      </div>
    );
  }

  const violationsList = violationsData.getAllViolationTypes.map((violation) => ({
    label: violation.violationName,
    value: violation.violationId + ", " + violation.violationStCode
  }));
  const anlyts = analyteData.getAllAnalytes.map((analyte) => ({
    label: analyte.analyteCode + " " + analyte.analyteName,
    value: analyte.analyteId
  }));
  const filteredGroups = groupData.getAllAnalyteGroups.filter((grp) => grp.groupId !== 23);
  const grps = filteredGroups.map((group) => ({
    label: group.groupCode + " " + group.groupName,
    value: group.groupId
  }));
  const analytesList = anlyts.concat(grps);

  return (
    <div className='page-container ips-violation-admin-container'>
      <Row>
        <Col>
          <Link className='m-2 hyperlink' to='/' cypressid='home-page'>
            Home
          </Link>
          <span className='m-2'>|</span>
          <Link className='m-2 hyperlink' to='/secure/module-index' cyressid='module-index'>
            Modules
          </Link>
          <span className='m-2'>|</span>
          <Link className='m-2 hyperlink' to='/secure/ips/ips-index' cyressid='ips-index'>
            IPS Menu
          </Link>
        </Col>
      </Row>
      <Row>
        <Col>
          <HeaderBox id={"gray-primary"} cypressid='ipsViolationsPage'>
            <h3 style={{ color: "#fff" }}>IPS Violations Admin</h3>
          </HeaderBox>
        </Col>
      </Row>

      {modalAG === "Analyte" && (
        <ModalWindow
          show={showAG}
          id={modalAG}
          handleClose={handleCloseAG}
          modalTitle={item?.anlytGrpName}
          item={item}
          component={AnalyteGroupForm}
        />
      )}
      {modalId && (
        <ModalWindow
          successMsg={submitSuccess}
          errorMsg={submitError}
          setSubmitSuccess={setSubmitSuccess}
          setSubmitError={setSubmitError}
          show={show}
          id={modalId}
          handleClose={handleClose}
          modalTitle={modalId + " Violation"}
          component={IpsViolationsForm}
          item={item}
          analytesList={analytesList}
          violationsList={violationsList}
          sectionsList={sectionData.getAllViolationSections}
          grps={grps}
          anlyts={anlyts}
          tableData={tableData.getIpsViolations}
        />
      )}
      <Row>
        <Col>
          <ButtonCreate id='ddw-primary' label='Add New' onClick={() => handleShow("Add")} style={{ float: "right" }} />
          <IpsViolationsTable
            data={tableData.getIpsViolations}
            handleShow={handleShow}
            handleShowAG={handleShowAG}
            setItem={setItemObj}
          />
        </Col>
      </Row>
    </div>
  );
};

export default IpsViolationAdminPage;
